export default {
  // Page Meta
  meta: {
    title: 'About Us | NutriBot',
    description: 'Discover how NutriBot is revolutionizing nutrition with AI-powered personalization, scientific precision, and intelligent automation.',
  },

  // Hero Section
  hero: {
    title: 'About Us',
    tagline: 'Nutrition reimagined. Precise. Personal. Intelligent.',
  },

  // Opening Statement
  opening: {
    paragraph1: 'Nutrition influences everything: health, energy, performance, quality of life, and longevity. Yet for decades, it has been complicated, contradictory, and confusing.',
    paragraph2: 'NutriBot changes that. Radically.',
    paragraph3: 'We developed NutriBot with a clear mission:',
    mission: 'Everyone deserves access to perfectly personalized nutrition — simple, intelligent, and scientifically grounded.',
  },

  // Vision Section
  vision: {
    title: 'Our Vision',
    intro: 'We believe in a future where nutrition is no longer guessed, but precisely calculated. A future where people achieve their goals without deprivation, without endless dieting, and without uncertainty.',
    goals: {
      title: 'Everything begins with the right nutrition — at the right time — for the right person.',
      items: [
        'Weight loss',
        'Muscle growth',
        'Health',
        'Prevention',
        'Performance',
      ],
    },
    statement: 'Our vision is to build the world\'s leading AI-powered nutrition platform and make nutrition as intuitive, personalized, and reliable as online banking or navigation.',
  },

  // What Makes Us Unique
  unique: {
    title: 'What Makes NutriBot Unique',
    subtitle: 'NutriBot is not a standard meal plan. It is an intelligent system.',
    features: [
      {
        icon: 'ri-brain-line',
        title: 'AI Intelligence',
        description: 'Artificial intelligence that analyzes individual data',
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Science-Based',
        description: 'Science-based algorithms instead of trends and myths',
      },
      {
        icon: 'ri-refresh-line',
        title: 'Dynamic Adaptation',
        description: 'Dynamic adaptation to lifestyle, progress, and goals',
      },
      {
        icon: 'ri-chat-4-line',
        title: '24/7 AI Coach',
        description: '24/7 AI coach that guides, motivates, and optimizes',
      },
      {
        icon: 'ri-shopping-cart-line',
        title: 'Automated Logic',
        description: 'Automated shopping and recipe logic for maximum everyday usability',
      },
    ],
    closing: 'NutriBot learns from every decision — and becomes better for you over time.',
  },

  // Target Audience
  audience: {
    title: 'Who We Built NutriBot For',
    subtitle: 'For people who want real results.',
    groups: [
      'For anyone who wants to lose weight — even without exercise',
      'For people with health-related challenges',
      'For professionals with no time for complex planning',
      'For those who want to trust their body again',
      'For beginners as well as ambitious high performers',
    ],
    closing: 'One platform. Countless life situations.',
  },

  // Values
  values: {
    title: 'Our Values',
    list: [
      {
        icon: 'ri-focus-line',
        title: 'Precision over chance',
        description: 'We work with data, not guesswork.',
      },
      {
        icon: 'ri-lightbulb-flash-line',
        title: 'Simplicity over overload',
        description: 'Complex processes — simple solutions.',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Trust over empty promises',
        description: 'Transparent, responsible, and reliable.',
      },
      {
        icon: 'ri-rocket-line',
        title: 'Technology in service of people',
        description: 'Not replacing — but empowering.',
      },
    ],
  },

  // Why NutriBot
  why: {
    title: 'Why NutriBot?',
    reasons: [
      'Because nutrition should never be a gamble.',
      'Because your body is unique.',
      'Because time is valuable.',
      'And because modern technology can do more today than ever before.',
    ],
    conclusion: 'NutriBot combines science, AI, and everyday life into a system that works.',
  },

  // CTA Footer
  cta: {
    brand: 'NutriBot.',
    tagline: 'Nutrition. Automated. Perfected.',
    primaryButton: 'Start for Free',
    secondaryButton: 'Learn More',
  },

  happyUsers: 'Happy Users'
};
